import * as React from 'react';
import { observer } from 'mobx-react';
import { getSharedFolderUserEmails } from 'owa-folders';
import SharedFolderTree from './SharedFolderTree';
import 'owa-mail-shared-folder-actions';
import { LazySharedFolderPeoplePicker } from 'owa-shared-folder';

export interface SharedFolderTreeParentContainerProps {
    className: string;
}

/**
 * Shared folder tree container
 */
function SharedFolderTreeParentContainer(props: SharedFolderTreeParentContainerProps) {
    return (
        <>
            {getSharedFolderUserEmails().map(principalSMTPAddress => {
                return (
                    <SharedFolderTree
                        key={principalSMTPAddress}
                        principalSMTPAddress={principalSMTPAddress}
                        className={props.className}
                    />
                );
            })}
            <LazySharedFolderPeoplePicker />
        </>
    );
}

export default observer(SharedFolderTreeParentContainer);
